import api from './api';

const BASE_PATH = '/slide_decks';

// O upload de um PDF de até 50 MB estoura fácil o timeout default de 15s da instance.
const UPLOAD_TIMEOUT_MS = 120000;

/**
 * Converte o documento JSON:API (chaves dash-case do SlideDeckSerializer)
 * em objeto plano camelCase usado pelo wizard.
 * Shape de entrada: { data: { id, attributes: { status, 'page-count', 'processed-pages', 'error-message' } } }
 */
export function parseSlideDeck(doc) {
  const resource = doc?.data;
  if (!resource) return null;
  const attributes = resource.attributes || {};
  return {
    id: Number(resource.id),
    status: attributes.status,
    pageCount: attributes['page-count'],
    processedPages: attributes['processed-pages'],
    errorMessage: attributes['error-message']
  };
}

/**
 * Cliente da API de slide decks (aula com slides em PDF).
 * Backend em backend/app/controllers/api/v1/slide_decks_controller.rb.
 */
export const slideDecksApi = {
  // Multipart de verdade: o backend lê params[:pdf], não JSON:API/base64.
  create: async pdfFile => {
    const formData = new FormData();
    formData.append('pdf', pdfFile);
    const doc = await api.post(BASE_PATH, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: UPLOAD_TIMEOUT_MS
    });
    return parseSlideDeck(doc);
  },

  show: async id => parseSlideDeck(await api.get(`${BASE_PATH}/${id}`)),

  retry: async id => parseSlideDeck(await api.post(`${BASE_PATH}/${id}/retry`))
};

export default slideDecksApi;
